export default __webpack_public_path__ + "static/media/icon.9d1820e5.png";